document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.head-button');
  const productLists = document.querySelectorAll('.product-list');
  const headLink = document.querySelector('.head-link');
  const blocksContainer = document.querySelector('.niccos-product-tabs__blocks');

  // Tab switching functionality
  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      buttons.forEach(btn => btn.classList.remove('active'));
      productLists.forEach(list => list.classList.remove('active'));
      button.classList.add('active');
      productLists[index].classList.add('active');
      headLink.setAttribute('href', button.getAttribute('data-href'));
    });
  });

  let isDown = false;
  let startX;
  let scrollLeft;

  blocksContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    blocksContainer.style.cursor = 'grabbing';
    startX = e.pageX - blocksContainer.offsetLeft;
    scrollLeft = blocksContainer.scrollLeft;
  });

  blocksContainer.addEventListener('mouseleave', () => {
    isDown = false;
    blocksContainer.style.cursor = 'grab';
  });

  blocksContainer.addEventListener('mouseup', () => {
    isDown = false;
    blocksContainer.style.cursor = 'grab';
  });

  blocksContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - blocksContainer.offsetLeft;
    const walk = (x - startX) * 2;
    blocksContainer.scrollLeft = scrollLeft - walk;
  });
}); 